import { BowlBlock, BowlField } from '@websolutespa/payload-plugin-bowl';

export const withIntegration = (integrationName: string, integrationFields: BowlField[]): BowlBlock => {

  integrationFields.forEach((field) => {
    field.admin = field.admin ?? {};
    field.admin.condition = (_, siblingData) => siblingData?.configSource === 'manual';
  });

  return {
    type: 'withBlock',
    slug: integrationName,
    fields: [
      {
        name: 'configSource',
        type: 'select',
        label: 'Scegli metodo di configurazione',
        options: [
          { label: 'Carica configurazione tramite variabile d\'ambiente o file JSON', value: 'dynamic' },
          { label: 'Inserisci manualmente', value: 'manual' },
        ],
        defaultValue: 'manual',
      },
      {
        name: '__from_env',
        type: 'withText',
        admin: {
          description: '__from_env',
          condition: (_, siblingData) => siblingData?.configSource === 'dynamic',
        },
      },
      {
        name: '__from_file',
        type: 'withText',
        admin: {
          description: '__from_file',
          condition: (_, siblingData) => siblingData?.configSource === 'dynamic',
        },
      },
      ...integrationFields,
    ],
  };
};
